import { Directive } from '@angular/core';

@Directive({
  selector: 'wchfs-hint',
})
export class Hint {}
